/**
 * InviteLinkContent styles
 */

import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getInviteLinkContentStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      minHeight: 220,
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 24,
      paddingHorizontal: 16,
    },
    iconCircle: {
      width: 56,
      height: 56,
      borderRadius: 28,
      backgroundColor: theme.primary + '15',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 16,
    },
    description: {
      fontSize: 14,
      color: theme.gray[600],
      textAlign: 'center',
      marginBottom: 20,
      lineHeight: 20,
    },
    urlContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.gray[100],
      borderRadius: 12,
      paddingHorizontal: 14,
      paddingVertical: 12,
      width: '100%',
      marginBottom: 16,
    },
    urlText: {
      flex: 1,
      fontSize: 13,
      color: theme.gray[700],
      marginRight: 8,
    },
    shareButtonFull: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.primary,
      borderRadius: 12,
      paddingVertical: 14,
      width: '100%',
      gap: 8,
    },
    shareButtonFullText: {
      fontSize: 15,
      fontWeight: '600',
      color: theme.onPrimary,
    },
    generateButton: {
      backgroundColor: theme.primary,
      borderRadius: 12,
      paddingVertical: 14,
      paddingHorizontal: 28,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 48,
    },
    generateButtonText: {
      fontSize: 16,
      fontWeight: '600',
      color: theme.onPrimary,
    },
    errorText: {
      fontSize: 14,
      color: theme.error,
      textAlign: 'center',
      marginBottom: 12,
    },
    retryButton: {
      paddingVertical: 8,
      paddingHorizontal: 20,
    },
    retryButtonText: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.primary,
    },
  });
